<div class="overlay" dir="rtl" (click)="close.emit()">
  <section class="map-image-dialog" role="dialog" aria-modal="true" aria-labelledby="map-dialog-title" (click)="$event.stopPropagation()">
    <div class="modal-head">
      <div>
        <div class="modal-title" id="map-dialog-title">{{ vehicle.strFullName || vehicle.strUnitID }}<span *ngIf="vehicle.strVehicleNo"> | {{ vehicle.strVehicleNo }}</span></div>
        <div class="modal-sub">
          IMEI: {{ vehicle.strUnitID }} | {{ statusLabel }} |
          {{ vehicle.iSpeed == null ? 'سرعت نامشخص' : (vehicle.iSpeed | faNum) + ' کیلومتر بر ساعت' }} |
          {{ vehicle.siAngle == null ? 'زاویه نامشخص' : 'زاویه ' + (vehicle.siAngle | faNum) + ' درجه' }}
        </div>
      </div>
      <button id="map-image-dialog-close" class="button" type="button" (click)="close.emit()">بستن</button>
    </div>
    <div class="tabs" aria-label="دسته تصویر">
      <button class="button" type="button" [class.active]="category === 'cabin'" [attr.aria-pressed]="category === 'cabin'" (click)="selectCategory('cabin')">کابین</button>
      <button class="button" type="button" [class.active]="category === 'outside'" [attr.aria-pressed]="category === 'outside'" (click)="selectCategory('outside')">بیرون</button>
      <button class="button" type="button" [class.active]="category === 'event'" [attr.aria-pressed]="category === 'event'" (click)="selectCategory('event')">وقایع</button>
    </div>
    <div class="modal-image-wrap">
      <img *ngIf="currentImage && !imageFailed" [src]="currentImage!.fullUrl" [alt]="'تصویر دوربین ' + (vehicle.strFullName || vehicle.strUnitID)" (error)="imageFailed = true">
      <div *ngIf="!currentImage || imageFailed" class="missing" role="status">{{ imageFailed ? 'تصویر در دسترس نیست.' : 'برای این خودرو در این دسته تصویری موجود نیست.' }}</div>
    </div>
    <div class="modal-foot">
      <span>آخرین موقعیت: {{ positionTime }} | <bdi>{{ vehicle.fLat }}, {{ vehicle.fLon }}</bdi></span>
      <button class="button primary" type="button" (click)="zoomVehicle.emit()">نمایش موقعیت روی نقشه</button>
    </div>
  </section>
</div>
